module.exports = __webpack_public_path__ + "img/148_thumbnail.0851dc38.jpg";